
import React, { useState, useEffect, useRef } from 'react';
import styles from './lazyText.module.css';

interface TextOnScrollProps {
    children: React.ReactNode; // Allow passing any JSX as content (e.g., <h3>, <p>, etc.)
}

const LazyText: React.FC<TextOnScrollProps> = ({ children }) => {
    const [isVisible, setIsVisible] = useState(false); // State to track visibility
    const textRef = useRef<HTMLDivElement | null>(null);

    // Handle scroll event and check if the text is at least 30% in the viewport
    const handleScroll = () => {
        if (textRef.current) {
            const rect = textRef.current.getBoundingClientRect();
            const viewportHeight = window.innerHeight;

            // Check if the text is at least 30% visible in the viewport
            const isInViewport = rect.top <= viewportHeight * 0.7 && rect.bottom >= viewportHeight * 0.3;

            // If we're scrolling back up and the text is completely out of the viewport, hide it
            const isAtTop = rect.top > viewportHeight;

            if (isInViewport || !isAtTop) {
                // Delay text visibility to give time for image to appear first
                setTimeout(() => setIsVisible(true), 300); // 500ms delay before making the text visible
            } else {
                setIsVisible(false);
            }
        }
    };

    useEffect(() => {
        // Set up scroll event listener
        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Check visibility on initial render

        return () => {
            // Clean up event listener on unmount
            window.removeEventListener('scroll', handleScroll);
        };
    }, []); // Only run once on mount

    return (
        <div ref={textRef} className={`${styles.text_section} ${isVisible ? styles.visible : ''}`}>
            {children} {/* Render passed children (e.g., <h3>, <p>, etc.) */}
        </div>
    );
};

export default LazyText;

